import t from './notification.type';
import * as notify from '../../../services/notification.service';
import { toasterMsg } from '../../../Components/Toaster/Toaster';

const translate = (translator, key, fallback) => {
  if (typeof translator !== 'function' || !key) return fallback;
  const value = translator(key);
  return value && value !== key ? value : fallback;
};

export const saveSetting = (data, chatEmailEnabled, translator) => async () => {
  try {
    const res = await notify.saveSettingService({ notificationSettings: data, chatEmailEnabled });
    if (res?.code === 200) {
      toasterMsg(translate(translator, 'NOTIFICATION_INDEX.SETTINGS_SAVED_SUCCESSFULLY', 'Settings saved successfully'), 'success');
    } else {
      const fallback = translate(translator, 'NOTIFICATION_INDEX.SETTINGS_SAVE_FAILED', 'Failed to save settings');
      toasterMsg(translate(translator, res?.data?.errMsg, fallback), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchNotificationList = (data, translator) => async (dispatch) => {
  try {
    const res = await notify.fetchNotificationListService(data);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_NOTIFICATION_LIST,
        payload: { data: res?.data, params: data },
      });
    } else {
      const fallback = translate(translator, 'NOTIFICATION_INDEX.SETTINGS_SAVE_FAILED', 'Failed to save settings');
      toasterMsg(translate(translator, res?.data?.errMsg, fallback), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateSocketbasedValue = (data) => async (dispatch) => {
  try {
    dispatch({
      type: t.UPDATE_SOCKET_NOTIFICATION,
      payload: data,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
